<template>
  <footer id="footer">
    <div class="footer-top" style="background:#004a59;">
      <div class="container">
        <div class="row">
          <div class="col-lg-3 col-md-3 col-sm-6 footer-links">
            <h4>Who we are</h4>
            <ul>
              <li>
                <router-link to="/">Home</router-link>
              </li>
              <li>
                <router-link to="/about-us">About Us</router-link>
              </li>
              <li>
                <router-link to="/privacy-policy">Privacy Policy</router-link>
              </li>
              <li>
                <router-link to="/terms-and-conditions">Terms and Conditions</router-link>
              </li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 footer-links">
            <h4>What we offer</h4>
            <ul>
              <li>
                <router-link to="/">Mobile Recharge</router-link>
              </li>
              <li>
                <router-link to="/">Packages</router-link>
              </li>
              <li>
                <router-link to="/">Operators</router-link>
              </li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-3 col-sm-6 footer-links">
            <h4>Help and Support</h4>
            <ul>
              <li><a href="#" v-scroll-to="'#contact'">Support</a></li>
              <li><a href="#" v-scroll-to="'#how-to-recharge'">How to recharge</a></li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-3 cpl-sm-6 footer-links">
            <h4>Social Media
            </h4>
            <div class="social-links mt-3">
              <a href="https://www.facebook.com/wintellimitedbd/" class="facebook" target="_blank"><i
                  class="bx bxl-facebook"></i></a>
              <a href="https://twitter.com/wintellimitedbd" class="tweeter" target="_blank"><i
                  class="bx bxl-twitter"></i></a>
              <a href="https://www.linkedin.com/company/wintel-limited/" class="linkedin"
                 target="_blank"><i class="bx bxl-linkedin"></i></a>
            </div>
          </div>
          <div class="col-lg-12 col-md-12 col-sm-12 payment-methods">
            <img src="assets/img/payments/bkash.png" alt="bkash">
            <img src="assets/img/payments/nagad.png" alt="nagad">
            <img src="assets/img/payments/rocket_pay.png" alt="rocket">
            <img src="assets/img/payments/master.png" alt="master">
            <img src="assets/img/payments/visa.png" alt="visa">
            <img src="assets/img/payments/nexus_payment.png" alt="nexus">
          </div>
        </div>
      </div>
    </div>

    <div class="container footer-bottom clearfix">
      <div class="copyright">
        &copy;2022 <strong><span><a class="wintel" target="_blank" href="https://wintelbd.com">Wintel Limited</a></span></strong>. All Rights Reserved.
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Information",
  props: {
    msg: String,
  },
};
</script>

<style scoped lang="scss">
.copyright {
  letter-spacing: 0.07em;
}
.wintel {
  color: #FFFFFF;
}
.payment-methods {
  margin-bottom: 30px;
  text-align: center;
}
.payment-methods img {
  margin: 0 30px;
  width: 80px;
}
</style>
